/* istanbul ignore file */

import type { IPaginationContext } from './models';

export const defaultPaginationContext: IPaginationContext = {
    currentPageNumber: 1,
    hideArrows: false,
    pages: 1,
    handlePageClick: () => () => {},
    handleShowMoreButtonClick: () => {},
};
